
import { Vue, Component, Prop } from 'vue-property-decorator';

import TickIcon from '@/components/icons/TickIcon.vue';
import Cross from '@/components/icons/Cross.vue';

@Component({
	components: {
		TickIcon,
		Cross,
	},
})
export default class Tabs extends Vue {
	@Prop({ type: Array, required: true }) tabs!: Array<{
		name: string;
		badge?: number;
	}>;
	@Prop({ type: Number, default: 0 }) activeTab!: number;
	@Prop({ default: () => [] }) readonly selectedRows: number[];

	@Prop({ type: Boolean, default: false }) isAdmin: number;

	setActiveTab(index: number) {
		this.activeTab = index;
		this.$emit('update:activeTab', index);
	}
	approveSelected() {
		this.$emit('approve-selected', this.selectedRows);
	}

	rejectSelected() {
		this.$emit('reject-selected', this.selectedRows);
	}
}
